






































import axios from 'axios';
import env from '@/env';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Attribute } from '@/types';

@Component({})
export default class EditAttributeDialog extends Vue {
  @Prop({ default: () => false })
  value?: boolean;

  @Prop({ default: () => ({}) })
  attribute?: Attribute;

  scope = 'default';

  @Watch('attribute')
  watchAttribute() {
    if (this.attribute?.local) {
      this.scope = 'local';
    } else if (this.attribute?.global) {
      this.scope = 'global';
    } else {
      this.scope = 'default';
    }
  }

  async handleSaveClick() {
    const attribute: Attribute = { ...this.attribute } as Attribute;
    if (this.scope === 'default') {
      attribute.global = false;
      attribute.local = false;
    } else if (this.scope === 'global') {
      attribute.global = true;
      attribute.local = false;
    } else if (this.scope === 'local') {
      attribute.global = false;
      attribute.local = true;
    }

    await axios.post(`${env.backend_url}/attribute/update`, attribute);
    this.$emit('close', attribute);
  }
}
